<template>
  <div class="i-summary-video">
    <iBaseHeader
      highlight-text=""
      text="3 Must-Know Takeaways From Your Career Report"
      font-size-text="16px"
      align="start"
    />

    <div class="video">
      <iframe
        id="vimeo-iframe"
        :src="`https://player.vimeo.com/video/1032158871?badge=0&amp;autoplay=0&amp;muted=1&amp;player_id=0&amp;app_id=58479`"
        frameborder="0"
        allow="fullscreen; picture-in-picture; clipboard-write"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      ></iframe>
    </div>
  </div>
</template>

<script setup lang="ts">
import iBaseHeader from "@/components/base/BaseHeader.vue"
</script>

<style lang="scss" scoped>
.i-summary-video {
  padding: 20px;
  width: 100%;
  height: 100%;

  @media screen and (min-width: $breakpoint-xl) {
    border-bottom: 1px solid $zumthor100;
    border-right: 1px solid $zumthor100;
  }

  .video {
    padding: 65% 0 0;
    position: relative;
    border-bottom: 1px solid $zumthor100;

    @media screen and (min-width: $breakpoint-xl) {
      border-bottom: none;
    }
  }
}
</style>
